import { render, staticRenderFns } from "./RotateSquare.vue?vue&type=template&id=3350cf5a"
import script from "./RotateSquare.vue?vue&type=script&lang=js"
export * from "./RotateSquare.vue?vue&type=script&lang=js"
import style0 from "./RotateSquare.vue?vue&type=style&index=0&id=3350cf5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports